import type {LangType} from './types'
import {TRANSLATES, DEFAULT_LANG} from './consts'

export const getTranslates = (lang?: LangType) => {
    if (lang) return TRANSLATES[lang]

    return TRANSLATES[DEFAULT_LANG]  
}
